import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ title, description, icon, iconColor, actionLabel, onClick }) => {
  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-elevation-1 hover:shadow-elevation-2 transition-smooth">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name={icon} size={20} color={iconColor || 'var(--color-primary)'} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm md:text-base font-heading font-semibold text-foreground mb-1">
            {title}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
            {description}
          </p>
        </div>
      </div>
      <Button 
        variant="outline" 
        fullWidth 
        onClick={onClick}
        iconName="ArrowRight"
        iconPosition="right"
        size="sm"
      >
        {actionLabel}
      </Button>
    </div>
  );
};

export default QuickActionCard;